<template>
    <div>
        <div v-if="display">
            <v-alert
                dense
                :type="aClass"
                prominent

            >
                <div class="text-h6">{{ title }}</div>
                <div>{{ text }}</div>
                <i style='float: right;'>Announcement last updated at: {{ getLastUpdatedDate }} </i>
            </v-alert>
        </div>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
            top
        >
            {{ snackbartext }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            title: "",
            aClass: "",
            text: "",
            display: false,
            lastUpdated: "",
            lastCreated: "",
            snackbar: false,
            snackbarcolor: "",
            snackbartext: "",
            timeout: 3500
        }
    }, 
    computed: {
        getLastUpdatedDate(){
            if(!this.lastUpdated){
                return this.lastCreated;
            }else {
                return this.lastUpdated;
            }
        }
    },
    methods: {
        getAnnouncement(){
            const that = this;

            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?getAnnouncements';

            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }
                    if(resultData.data){
                        for(var i=0; i < resultData.data.length; i++){
                            if(resultData.data[i].type == that.type){
                                if(resultData.data[i].display == "no"){
                                    that.display = false;
                                }else if(resultData.data[i].display == "yes"){
                                    that.title = resultData.data[i].title;
                                    that.text = resultData.data[i].text;
                                    that.aClass = resultData.data[i].class;
                                    that.lastUpdated = resultData.data[i].lastUpdatedDateTime;
                                    that.lastCreated = resultData.data[i].createdDateTime;
                                    that.display = true;
                                }else {
                                    that.display = false;
                                }
                            }
                        }
                    }

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API GET request
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.snackbartext = msg;
        }
    },
    created(){
        const that = this;
        that.getAnnouncement();
    }
}
</script>